import { dictValue } from './i18n/index.jsx';

// Marketplace category slugs (migrations/002) covered by each built-in
// sector (used until sectors are published from Website content).
export const CATEGORIES = {
  metals: 'metals',
  'food-agriculture': 'food-beverages,agriculture',
  'building-materials': 'building-materials,wood-forest',
  'machinery-equipment': 'machinery-equipment,auto-parts',
  'electrical-electronics': 'electrical-electronics',
  'packaging-plastics': 'packaging,chemicals-plastics',
  'textiles-consumer-goods': 'textiles-apparel,health-beauty,home-furniture',
};

// Built-in sectors as an editable document. Departments start from each
// sector's example products (first 6, text before ":"), with no photo and
// no category yet: on the site they search within the sector until a
// category is chosen. Stats default to automatic (real counts only).
const deptName = (p) => String(p || '').split(/\s*:\s*/)[0].trim();
// Example 3-level structure (names only — no photos, no prices): Metals ›
// Long steel › 6 product types. Part of the built-in Metals sector, and
// insertable from Admin when sectors are already published.
const bi = (fr, en) => ({ fr, en, auto: null });
const blank = () => bi('', '');
const type = (id, fr, en) => ({ id, hidden: false, name: bi(fr, en), slugFr: '', slugEn: '', title: blank(), description: blank(), photos: [], badges: [], categorySlug: '', related: [], specs: [] });
export const LONG_STEEL_EXAMPLE = () => ({
  id: 'lsteel', name: bi('Acier long', 'Long steel'), photo: '', categorySlug: '', slugFr: '', slugEn: '',
  title: blank(), subtitle: blank(), description: blank(), badges: [], specIntro: blank(), specFooter: blank(), related: [], prices: [],
  types: [
    type('tmt', 'TMT', 'TMT'), type('angles', 'Cornières', 'Angles'), type('channels', 'Profilés en U', 'Channels'),
    type('beams', 'Poutrelles', 'Beams'), type('mspipes', 'Tubes en acier doux', 'MS pipes'), type('dipipes', 'Tuyaux en fonte ductile', 'DI pipes'),
  ],
});

export function sectorDefaults() {
  const fr = dictValue('fr', 'sectors.items') || [];
  const en = dictValue('en', 'sectors.items') || [];
  const pair = (a, b) => ({ fr: a || '', en: b || '', auto: null });
  return {
    items: fr.map((s, i) => {
      const e = en.find((x) => x.key === s.key) || en[i] || {};
      return {
        key: s.key, hidden: false, photo: `/sectors/${s.key}.webp`, categories: CATEGORIES[s.key] || '',
        name: pair(s.name, e.name), tagline: pair(s.tagline, e.tagline), browse: pair('', ''),
        paragraphs: pair((s.paragraphs || []).join('\n\n'), (e.paragraphs || []).join('\n\n')),
        products: pair((s.products || []).join('\n'), (e.products || []).join('\n')),
        statsMode: 'auto', stat1: pair('', ''), stat2: pair('', ''), stat1Icon: 'users', stat2Icon: 'box',
        departments: [
          ...(s.key === 'metals' ? [LONG_STEEL_EXAMPLE()] : []),
          ...(s.products || []).slice(0, s.key === 'metals' ? 5 : 6).map((p, j) => ({
            id: `${s.key.slice(0, 6)}${j}`.replace(/[^a-z0-9]/gi, ''), name: pair(deptName(p), deptName((e.products || [])[j])), photo: '', categorySlug: '', types: [],
          })),
        ],
      };
    }),
  };
}


// Stats strap under a sector's departments (Admin > Website content >
// Sectors > "Stats strap"). Sectors saved before the strap existed are
// read from their old stats line: automatic counts, two custom texts, or
// hidden. The right-hand link starts hidden ("coming soon").
export const STRAP_SPEEDS = ['slow', 'normal', 'fast'];
export const STRAP_TARGETS = ['hidden', 'marketplace', 'sector', 'url'];
export const STRAP_MAX_ITEMS = 8;
const strapId = () => Math.random().toString(36).slice(2, 10);
export const strapItem = (c = {}) => ({ id: strapId(), icon: 'truck', iconUrl: '', text: blank(), auto: '', ...c });
export function strapOf(s) {
  if (s?.strap && typeof s.strap === 'object') return s.strap;
  const mode = s?.statsMode || 'auto';
  const items = mode === 'custom'
    ? [[s.stat1, s.stat1Icon], [s.stat2, s.stat2Icon]].filter(([v]) => v?.fr || v?.en).map(([v, icon], i) => strapItem({ id: `legacy${i}`, icon: icon || 'users', text: v }))
    : mode === 'auto' ? [strapItem({ id: 'legacy0', icon: 'users', auto: 'sellers' }), strapItem({ id: 'legacy1', icon: 'box', auto: 'listings' })] : [];
  return { show: mode !== 'none', scroll: false, speed: 'normal', items, link: { text: s?.browse || blank(), target: 'hidden', url: '' } };
}
